/*
 * @Author: kangkang 1278279046@qq.com
 * @Date: 2022-06-08 10:53:19
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-06-08 10:54:02
 * @FilePath: \experience-pc\src\util\eventBus.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'Vue'

export default new Vue;


// WEBPACK FOOTER //
// ./src/util/eventBus.js